import { Component, OnInit, HostListener, ViewChild, Input, ElementRef } from '@angular/core';
import { MultipleDonutGraphConfigurations } from "../../charts/multiple-donut/multiple-donut.configuration";
import { TitleConfigurations, TitleLineConfigurations } from "../title/title.configurations";
import {KlaHttpService} from "../services/kla.http.service";
import { CommonModule } from '@angular/common';
import { TitleComponent } from '../title/title.component';
import { MultipleDonutComponent } from 'app/shared/charts/multiple-donut/multiple-donut.component';

@Component({
  selector: 'kla-indicator-multiple-rings',
  templateUrl: './indicator-multiple-rings.component.html',
  styleUrls: ['./indicator-multiple-rings.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent, MultipleDonutComponent ]
})
export class IndicatorMultipleRingsComponent implements OnInit {

  @ViewChild('donutPanel', {static: true})
  public panel:ElementRef;

  @Input()
  public config: {
    image:string,
    title: TitleConfigurations,
    chartId: string
  };
  
  @Input()
  public lineConfig: TitleLineConfigurations;

  public chartConfig: MultipleDonutGraphConfigurations;

  public showChart: boolean = false;

  constructor(private http: KlaHttpService) {
    this.chartConfig = {
      width: 500,
      height: 368,
      thickness: 40,
      image:"",
      data: null
    }
   }

  ngOnInit() {
    this.chartConfig.image = this.config.image;
    this.findChartData();
  }

  private findChartData() {
    this.http.getChartData("kla-multiple-donut", this.config.chartId).subscribe(
      (data) => {
        this.chartConfig.data = data;
        this.showChart = true;
        if (!this.chartConfig.data) {
          console.error("Please provide bar chart configurations");
        } else {
          this.resize();
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  @HostListener('window:resize')
  onResize() {
    this.resize();
  }
  private resize() {
    let rectangle = this.panel.nativeElement.getBoundingClientRect();

    if(rectangle.width > 500 ){
      this.chartConfig.width = 500;
    }
    else if(rectangle.width  < 500 && rectangle.width  > 450){
      this.chartConfig.width = 480;
    }else if(rectangle.width > 344 && rectangle.width < 399){
      this.chartConfig.width = rectangle.width-20;
    }else if(rectangle.width < 345){
      this.chartConfig.width = 320;
    }
  }

}
